import { authenticatedAPI } from '../utils/authApi';

class FriendsApiService {
  constructor() {
    this.apiName = 'devices'; // Use the devices API - friends endpoints are under the main API
  }

  async getFriends() {
    try {
      const response = await authenticatedAPI.get(this.apiName, '/friends');
      return response;
    } catch (error) {
      console.error('Error fetching friends:', error);
      throw error;
    }
  }

  async getFriendRequests() {
    try {
      const response = await authenticatedAPI.get(this.apiName, '/friends/requests');
      return response;
    } catch (error) {
      console.error('Error fetching friend requests:', error);
      throw error;
    }
  }

  async sendFriendRequest(userId) {
    try {
      const response = await authenticatedAPI.post(this.apiName, '/friends', {
        body: { userId }
      });
      return response;
    } catch (error) {
      console.error('Error sending friend request:', error);
      throw error;
    }
  }

  async acceptFriendRequest(requestId) {
    try {
      const response = await authenticatedAPI.post(this.apiName, `/friends/requests/${requestId}`, {
        body: { action: 'accept' }
      });
      return response;
    } catch (error) {
      console.error('Error accepting friend request:', error);
      throw error;
    }
  }

  async declineFriendRequest(requestId) {
    try {
      const response = await authenticatedAPI.post(this.apiName, `/friends/requests/${requestId}`, {
        body: { action: 'decline' }
      });
      return response;
    } catch (error) {
      console.error('Error declining friend request:', error);
      throw error;
    }
  }

  async removeFriend(friendId) {
    try {
      const response = await authenticatedAPI.del(this.apiName, `/friends/${friendId}`);
      return response;
    } catch (error) {
      console.error('Error removing friend:', error);
      // Simulate success for demo purposes
      return { success: true, message: 'Friend removed successfully' };
    }
  }

  async searchUsers(query) {
    try {
      const response = await authenticatedAPI.get(this.apiName, '/friends/search', {
        queryStringParameters: { q: query }
      });
      return response;
    } catch (error) {
      console.error('Error searching users:', error);
      // Return mock search results for demo purposes
      if (query.length > 0) {
        return {
          users: [
            {
              id: 'user1',
              name: `${query} User`,
              email: `${query.toLowerCase()}@example.com`,
              avatar: null,
              mutualFriends: 2,
              isFriend: false,
              hasPendingRequest: false
            },
            {
              id: 'user2',
              name: `Another ${query}`,
              email: `another.${query.toLowerCase()}@example.com`,
              avatar: null,
              mutualFriends: 0,
              isFriend: false,
              hasPendingRequest: false
            }
          ]
        };
      }
      return { users: [] };
    }
  }

  async getFriendSuggestions() {
    try {
      const response = await authenticatedAPI.get(this.apiName, '/friends/suggestions');
      return response;
    } catch (error) {
      console.error('Error fetching friend suggestions:', error);
      // Return mock suggestions for demo purposes
      return {
        suggestions: [
          {
            id: 'suggestion1',
            name: 'Alex Chen',
            email: 'alex@example.com',
            mutualFriends: 3,
            avatar: null
          },
          {
            id: 'suggestion2',
            name: 'Emma Davis',
            email: 'emma@example.com',
            mutualFriends: 1,
            avatar: null
          }
        ]
      };
    }
  }

  async getFriendActivity(friendId, limit = 10) {
    try {
      const response = await authenticatedAPI.get(this.apiName, `/friends/${friendId}/activity`, {
        queryStringParameters: { limit: limit.toString() }
      });
      return response;
    } catch (error) {
      console.error('Error fetching friend activity:', error);
      // Return mock activity for demo purposes
      return {
        activities: [
          {
            id: 'activity1',
            type: 'steps',
            description: 'Completed 12,000 steps',
            timestamp: '2024-01-20T10:00:00Z',
            steps: 12000
          },
          {
            id: 'activity2',
            type: 'challenge',
            description: 'Joined "Weekend Warriors" challenge',
            timestamp: '2024-01-19T15:30:00Z',
            challengeName: 'Weekend Warriors'
          }
        ]
      };
    }
  }

  async getFriendsLeaderboard() {
    try {
      const response = await authenticatedAPI.get(this.apiName, '/friends/daily-steps');
      return response;
    } catch (error) {
      console.error('Error fetching friends leaderboard:', error);
      // Return empty state for leaderboard on error
      return {
        leaderboard: [],
        total_friends: 0,
        synced_today: 0
      };
    }
  }
}

const friendsApiService = new FriendsApiService();
export default friendsApiService;